import { render, staticRenderFns } from "./ReportNavigation.vue?vue&type=template&id=95bfbe8a&"
import script from "./ReportNavigation.vue?vue&type=script&lang=js&"
export * from "./ReportNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95bfbe8a')) {
      api.createRecord('95bfbe8a', component.options)
    } else {
      api.reload('95bfbe8a', component.options)
    }
    module.hot.accept("./ReportNavigation.vue?vue&type=template&id=95bfbe8a&", function () {
      api.rerender('95bfbe8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/ReportNavigation.vue"
export default component.exports